const tabs = () => {
  const container = document.querySelector("[data-tabs]");
  if (!container) return;

  const tabs = container.querySelectorAll(".tabs .tab");
  const lines = container.querySelectorAll(".tabs_content .line");
  const icons = container.querySelectorAll(".tabs_content .icon img");

  const descriptions = container.querySelectorAll(".tabs_description .column");

  tabs.forEach((tab, idx) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t, i) => t.classList.toggle("active", i == idx));
      descriptions.forEach((d, i) => d.classList.toggle("active", i == idx));
      icons && icons.forEach((c, i) => c.classList.toggle("active", i == idx));
      lines && lines.forEach((l, i) => l.classList.toggle("active", i < idx));
    });
  });
};

export default tabs;
